<template lang="pug">
div
  Form(:data="value", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useValueAdd from './useValueAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, value, isSubmitting } = useValueAdd()

    return {
      value,
      create,
      isSubmitting,
    }
  },
}
</script>
